import { useEffect } from 'react'
import { useAuthStore } from '../store/authStore'
import { useLanguageStore } from '../store/languageStore'

export type Language = 'es' | 'en' | 'ca'

export function useLanguage() {
  const { user } = useAuthStore()
  const { language, initializeFromUser } = useLanguageStore()
  
  // Inicializar idioma desde user.configuracion cuando cambia el usuario
  useEffect(() => {
    if (user?.configuracion) {
      initializeFromUser(user.configuracion)
    } else {
      initializeFromUser(null)
    }
  }, [user?.configuracion, user, initializeFromUser])
  
  return language
}

